import React from "react";
import { modal } from "../modal";

export const modal_roomimage = props => {
  const { imageUrl } = props;
  return (
    <div className="modal_roomimage modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="roomimg_container">
      { imageUrl.map((url, index) => {
        return(
         <img src= { url } />
         );
        })
      }
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_roomimage.jsx